export default __webpack_public_path__ + "static/media/activate.dd610da4.svg";